const Generic = require("../GenericThemeFunctions")

module.exports = {
    scssVariables: './src/styles/lehmann',
    defaultLanguage: 'es',
    randomNickname:  () => { return Generic.RandomNickname() },
    favicon: 'lehmanfavicon.ico',
    defaultPassword: 'lehmann'
}